export default __webpack_public_path__ + "media/Objective/Objective-ExtraBold-15c5308e8cecfaf3720df0da8c462577.woff2";